module.exports = __webpack_public_path__ + "img/membership_new.f3730a46.gif";